import { AnyFn, IIdentity } from '.';

export interface RowConfig<T extends IIdentity> {
  allowDeleting?: AnyFn;
  allowSelection?: AnyFn;
  isEmpty?: (data: T) => boolean;
  height?: number;
}
